// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageHeader__PageHeader-module--EY32a {
    margin-bottom: var(--space-md);
}

.titleRow__PageHeader-module--dQko3 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-sm);
}

.titleGroup__PageHeader-module--um2Xu {
    display: flex;
    align-items: center;
    gap: var(--space-sm);
    min-width: 0;
}

.title__PageHeader-module--NANeG {
    margin-bottom: var(--space-2xs);
}

.icon__PageHeader-module--cTFun {
    flex-shrink: 0;
}

.action__PageHeader-module--TxoGn {
    flex-shrink: 0;
}

.subtitle__PageHeader-module--qwbVA {
    margin-bottom: var(--space-2xs);
    color: var(--color-text-tertiary);
}

.tags__PageHeader-module--zZIuP {
    margin-top: var(--space-2xs);
}
`, "",{"version":3,"sources":["webpack://./vector/src/PageHeader/PageHeader.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":[".pageHeader {\n    margin-bottom: var(--space-md);\n}\n\n.titleRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: var(--space-sm);\n}\n\n.titleGroup {\n    display: flex;\n    align-items: center;\n    gap: var(--space-sm);\n    min-width: 0;\n}\n\n.title {\n    margin-bottom: var(--space-2xs);\n}\n\n.icon {\n    flex-shrink: 0;\n}\n\n.action {\n    flex-shrink: 0;\n}\n\n.subtitle {\n    margin-bottom: var(--space-2xs);\n    color: var(--color-text-tertiary);\n}\n\n.tags {\n    margin-top: var(--space-2xs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `pageHeader__PageHeader-module--EY32a`,
	"titleRow": `titleRow__PageHeader-module--dQko3`,
	"titleGroup": `titleGroup__PageHeader-module--um2Xu`,
	"title": `title__PageHeader-module--NANeG`,
	"icon": `icon__PageHeader-module--cTFun`,
	"action": `action__PageHeader-module--TxoGn`,
	"subtitle": `subtitle__PageHeader-module--qwbVA`,
	"tags": `tags__PageHeader-module--zZIuP`
};
export default ___CSS_LOADER_EXPORT___;
